import $ from "jquery";
import CookieConsent from "@alpaga/cookie-consent";
$(document).ready(function () {
    var lang = $("html").attr("lang") == "fr-FR" ? "fr" : "en";
    var cookies = {
        fr: {
            locale: "fr",
            documentNode: "#inline-cookie-consent-banner",
            labels: {
                showCookie: "Afficher les cookies",
                table: {
                    name: "Nom",
                    provider: "Fournisseur",
                    purpose: "Objectif",
                    expiry: "Expire",
                    type: "Type"
                },
                "switch": {
                    on: "Oui",
                    off: "Non"
                },
                actions: {
                    more: "En savoir plus ?",
                    modifyDetails: "Modifier les préférences",
                    allow: {
                        all: "Accepter tous les cookies",
                        selected: "Accepter tous les cookies sélectionnés"
                    },
                    read: {
                        policy: "Consulter notre page d'information sur les cookies incluse dans notre politique de confidentialité"
                    },
                    cancel: "Annuler",
                    view: {
                        advanced: "Choix avancé",
                        simple: "Choix simple"
                    }
                }
            },
            content: {
                link: "/politique-de-la-vie-privee/",
                banner: {
                    title: "En utilisant ce site, vous acceptez l'utilisation des cookies. "
                },
                popup: {
                    title: "Ce site utilise des cookies. ",
                    description: "Ce site utilise des cookies. Nous utilisons des cookies pour que notre site web fonctionne au mieux, améliorant ainsi votre expérience en ligne. Afin d’en savoir plus sur l’utilisation des cookies, les plug-ins pour les réseaux sociaux ainsi que le web tracking, n’hésitez pas à consulter les informations sur les Cookies incluses dans notre Politique de Protection des Données personnelles."
                }
            },
            cookies: {
                'necessary': {
                    name: "necessary",
                    disabled: true,
                    value: true,
                    title: "Cookies nécessaires",
                    description: "Les cookies nécessaires aident à rendre un site Web utilisable en activant de base des fonctions telles que la navigation sur les pages et l'accès aux zones sécurisées du site Web. Le site Web ne peut pas fonctionner correctement sans ces cookies.",
                    "function": function () { },
                    cookies: [
                        {
                            name: "CookieConsent",
                            provider: "Assar",
                            purpose: "Stocke l'état de consentement des cookies de l'utilisateur pour le domaine actuel",
                            expiry: "1 an",
                            type: "HTTP"
                        },
                        {
                            name: "pll_language",
                            provider: "Assar",
                            purpose: "Stocke la langue de l'utilisateur pour lui proposer les contenus dans sa langue lors de sa prochaine visite.",
                            expiry: "1 an",
                            type: "HTTP"
                        },
                    ]
                },
                analytics: {
                    name: "analytics",
                    value: false,
                    title: "Cookies analytiques",
                    "function": function () {
                        analyticsFn();
                    },
                    description: "Les cookies analytiques aident les propriétaires de sites Web à comprendre comment les visiteurs \
                    interagissent avec les sites Web en collectant et en signalant des informations de manière anonyme.",
                    cookies: [
                        {
                            name: "_ga",
                            provider: "Google",
                            purpose: "Enregistre un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web.",
                            expiry: "2 ans",
                            type: "HTTP"
                        },
                        {
                            name: "_gat",
                            provider: "Google",
                            purpose: "Utilisé par Google Analytics pour réduire le taux de demandes",
                            expiry: "1 jour",
                            type: "HTTP"
                        },
                        {
                            name: "_gid",
                            provider: "Google",
                            purpose: "Enregistre un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web.",
                            expiry: "1 jour",
                            type: "HTTP"
                        }
                    ]
                }
            }
        },
        en: {
            locale: "en",
            documentNode: "#inline-cookie-consent-banner",
            labels: {
                showCookie: "Show cookies",
                table: {
                    name: "Name",
                    provider: "Provider",
                    purpose: "Purpose",
                    expiry: "Expiry",
                    type: "Type"
                },
                "switch": {
                    on: "On",
                    off: "Off"
                },
                actions: {
                    more: "Want to know more?",
                    modifyDetails: "Modify preferences",
                    allow: {
                        all: "Allow all cookies",
                        selected: "Allow selected cookies"
                    },
                    read: {
                        policy: "please see our Cookie Information page included on our Privacy Policy"
                    },
                    cancel: "Cancel",
                    view: {
                        advanced: "Advanced cookie choices",
                        simple: "Simple cookie choices"
                    }
                }
            },
            content: {
                link: "/privacy-policy/",
                banner: {
                    title: "By using this site, you agree to the use of cookies. "
                },
                popup: {
                    title: "This site uses cookies.",
                    description: "This site uses cookies. We use cookies to make our website work better, enhancing your online experience. To learn more about the use of cookies, social networking plug-ins and web tracking, please see our Cookie Information page included on our Privacy Policy."
                }
            },
            cookies: {
                'necessary': {
                    name: "necessary",
                    disabled: true,
                    value: true,
                    title: "Necessary Cookies",
                    description: "Necessary cookies help make a website usable by enabling basic\
                    functions like page navigation and access to secure areas of the website. The website cannot\
                    function properly without these cookies.",
                    "function": function () { },
                    cookies: [
                        {
                            name: "CookieConsent",
                            provider: "cookieconsent.extension",
                            purpose: "Stores the user's cookie consent state for the current domain",
                            expiry: "1 year",
                            type: "HTTP"
                        },
                        {
                            name: "pll_language",
                            provider: "Assar",
                            purpose: "Store the user's language for providing dedicated content",
                            expiry: "1 year",
                            type: "HTTP"
                        },
                    ]
                },
                analytics: {
                    name: "analytics",
                    value: false,
                    title: "Analytics Cookies",
                    "function": function () {
                        analyticsFn();
                    },
                    description: "Analytic cookies help website owners to understand how visitors\
                    interact with websites by collecting and reporting information anonymously.",
                    cookies: [
                        {
                            name: "_ga",
                            provider: "Google",
                            purpose: "Registers a unique ID that is used to generate statistical data on how the visitor uses the website.",
                            expiry: "2 years",
                            type: "HTTP"
                        },
                        {
                            name: "_gat",
                            provider: "Google",
                            purpose: "Used by Google Analytics to throttle request rate",
                            expiry: "1 day",
                            type: "HTTP"
                        },
                        {
                            name: "_gid",
                            provider: "Google",
                            purpose: "Registers a unique ID that is used to generate statistical data on how the visitor uses the website.",
                            expiry: "1 day",
                            type: "HTTP"
                        }
                    ]
                }
            }
        }
    };
    var CookieConsentNode = new CookieConsent(cookies[lang]);
    if ($("#inline-cookie-consent-banner").length) {
        CookieConsentNode.displayInlineContent();
    }
    $(".show-details-pop-up, .show-details-pop-up").on("click", function (e) {
        e.preventDefault();
        CookieConsentNode.showDetails();
    });
    CookieConsentNode.init();
});
